import { Doughnut } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';

Chart.register(ArcElement, Tooltip, Legend);

export default function CircleDiagram({data}) {
    const chartData = {
        labels: ['ON', 'PB95', 'LPG', 'ON+', 'PB98', 'AdBlue'],
        datasets: [
            {
                label: 'Ilość',
                data: [
                    data.on,
                    data.pb95,
                    data.lpg,
                    data.onplus,
                    data.pb98,
                    data.adb,
                ],
                backgroundColor: [
                    '#252525',
                    '#82c76d',
                    '#ba5959',
                    '#383875',
                    '#387549',
                    '#72b6cf'
                ],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
        },
    };

    return (
        <div className='circle-chart'>
            <Doughnut data={chartData} options={options}/>
        </div>
    );
}